import ContentContainer from "layout/Content/ContentContainer";
import useEntity from "hooks/useEntity";
import Loader from "components/ui/Loader/Loader";
import Alert from "components/ui/Alert/Alert";
import Paragraphs from "components/ui/Paragraphs/Paragraphs";
import {useTitle} from "../../hooks/useTitle";
import CookieDeclaration from "../../components/cookiebot/CookieDeclaration";
import TopBanner from "../../layout/TopBanner/TopBanner";

function Cookies({ title, topBanner, topBannerImage }) {
  const { entity, error, loading } = useEntity('/cookies', 'page');
  useTitle('Cookies');
  if (loading) {
    return <Loader containerVariant={ 'fixed' }/>;
  }

  if (error) {
    return <Alert message={ error }/>;
  }

  if (!entity) {
    return <Alert message={ 'Er is geen inhoud beschikbaar voor de opgevraagde pagina' }/>;
  }

  return (
    <>
      {
        topBanner && <TopBanner title={ title || entity.title.value }
                                intro={ entity.field_intro?.value }
                                image={ topBannerImage }/>
      }

      <ContentContainer contentGridType={ 'small' }
                        contentPadding={ true }
                        contentBackground={ true }
                        containerPadding={ true }>
        <h1>{ entity.title.value }</h1>
        { entity.field_content ? <Paragraphs items={ entity.field_content }/> : null }
        <CookieDeclaration/>
      </ContentContainer>

    </>
  );
}

export default Cookies;
